exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#rating-inline[data-v-34a34b5d]{\r\n\tdisplay: inline !important;\r\n    padding: 0;\r\n    width: auto !important;\n}\n#rating-inline .b-rating-star[data-v-34a34b5d]{\r\n\tpadding: 0 5px 0 0 !important;\n}\n.spaced-title[data-v-34a34b5d]{\r\n\tletter-spacing: 0.9px;\n}\r\n", ""]);

// exports
